import i18next from 'i18next';
import { CampaignProgressStatus, CampaignStatus } from 'infrastructure/enums';

export interface ICampaignProgressStatusItem {
  id: CampaignProgressStatus | null;
  name: string;
  color?: string;
}

export const campaignProgressStatusesDataSource = (
  withAll = true,
): ICampaignProgressStatusItem[] => {
  const dataSource: ICampaignProgressStatusItem[] = [
    {
      id: CampaignProgressStatus.NotStarted,
      name: i18next.t('campaignStatuses.notStarted'),
    },
    {
      id: CampaignProgressStatus.Pending,
      name: i18next.t('campaignStatuses.smsQueued'),
      color: '#667180',
    },
    {
      id: CampaignProgressStatus.Sent,
      name: i18next.t('campaignStatuses.sent'),
      color: '#667180',
    },
    {
      id: CampaignProgressStatus.Failed,
      name: i18next.t('campaignStatuses.smsNotSent'),
      color: '#972b2f',
    },
    {
      id: CampaignProgressStatus.Delivered,
      name: i18next.t('campaignStatuses.delivered'),
      color: '#6b667b',
    },
    {
      id: CampaignProgressStatus.Completed,
      name: i18next.t('campaignStatuses.completed'),
      color: '#266A1A',
    },
  ];

  if (withAll) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};

export interface ICampaignStatusItem {
  id: CampaignStatus | null;
  name: string;
}

export const campaignStatusesDataSource = (
  withAll = true,
): ICampaignStatusItem[] => {
  const dataSource: ICampaignStatusItem[] = [
    {
      id: CampaignStatus.Active,
      name: i18next.t('campaignStatuses.active'),
    },
    {
      id: CampaignStatus.Inactive,
      name: i18next.t('campaignStatuses.inactive'),
    },
  ];

  if (withAll) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};
